import {
	DonationContext,
	donationContextKey,
	DonationRecipient,
} from '../../services/donationsApi';
import LS from '../../utils/localStorageUtils';
import { Package } from '../types';

/**
 * A web payment's result comes back later keyed by the deposit only (the checkout tab, or Stripe's
 * Link button in this page), so the deposit leaves next to it what `usePaymentStatus` shows: the
 * package bought and, for a donation, who received it and what.
 */
export function rememberDeposit({
	depositId,
	packageData,
	pkg,
	recipient,
}: {
	depositId: string | undefined;
	packageData: unknown;
	pkg: Package;
	recipient?: DonationRecipient;
}): void {
	if (!depositId) return;

	if (packageData) {
		try {
			LS.set(`package_${depositId}`, JSON.stringify(packageData));
		} catch (e) {
			console.error('[rememberDeposit] Failed to save package info:', e);
		}
	}

	if (recipient) {
		const donation: DonationContext = {
			recipientPlayerId: recipient.playerId,
			recipientUsername: recipient.username,
			type: pkg.type === 'VIP_MEMBERSHIP' ? 'VIP' : 'CHIPS',
			chipAmount: pkg.chipAmount ?? pkg.chips,
			vipDurationDays: pkg.vipDurationDays,
		};
		try {
			LS.set(donationContextKey(depositId), JSON.stringify(donation));
		} catch (e) {
			console.error('[rememberDeposit] Failed to save donation context:', e);
		}
	}
}
